import { useTranslation } from "react-i18next";
import { PLATFORM_TABS } from "./platformTabList";

// شريط تبويبات لوحة المالك — يلتفّ بالعرض الكامل بدل التمرير الأفقي، وكل تبويب بلون مميّز.
export const PlatformTabs = ({ active, onChange, counts = {} }) => {
  const { t } = useTranslation();

  return (
    <nav
      className="sticky top-0 z-30 -mx-5 mt-6 bg-background/95 px-5 py-3 backdrop-blur sm:-mx-8 sm:px-8 lg:-mx-12 lg:px-12"
      data-testid="platform-tabs"
    >
      <div className="flex flex-wrap gap-2">
        {PLATFORM_TABS.map(({ key, icon: Icon, countKey, alert, iconCls, activeCls }) => {
          const count = countKey ? counts[countKey] || 0 : null;
          const isActive = active === key;
          return (
            <button
              key={key}
              type="button"
              data-testid={`platform-tab-${key}`}
              onClick={() => onChange(key)}
              className={`flex items-center gap-2 rounded-2xl bg-background px-3.5 py-2.5 text-sm font-bold transition-[box-shadow,color,transform] duration-300 hover:-translate-y-0.5 ${
                isActive ? `${activeCls} shadow-neu-in` : "text-muted-foreground shadow-neu-sm"
              }`}
            >
              <Icon className={`h-4 w-4 ${isActive ? activeCls : iconCls}`} />
              <span className="whitespace-nowrap">{t(`platform.tabs.${key}`)}</span>
              {count ? (
                <span
                  className={`rounded-full px-2 py-0.5 font-mono text-[10px] ${
                    alert ? "bg-destructive/15 text-destructive" : "bg-primary/10 text-primary"
                  }`}
                >
                  {count}
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
    </nav>
  );
};
